// Maps aliases/ISO-2 codes/alternate spellings → canonical full country name.
// Keys are lowercased for case-insensitive lookup.
const COUNTRY_ALIASES: Record<string, string> = {
  // United Kingdom
  'uk': 'United Kingdom',
  'gb': 'United Kingdom',
  'great britain': 'United Kingdom',
  'britain': 'United Kingdom',
  'england': 'United Kingdom',
  'scotland': 'United Kingdom',
  'wales': 'United Kingdom',
  'northern ireland': 'United Kingdom',

  // United States
  'us': 'United States',
  'usa': 'United States',
  'united states of america': 'United States',
  'u.s.': 'United States',
  'u.s.a.': 'United States',
  'america': 'United States',

  // Common ISO-2 codes and alternate spellings
  'be': 'Belgium',
  'de': 'Germany',
  'fr': 'France',
  'nl': 'Netherlands',
  'the netherlands': 'Netherlands',
  'holland': 'Netherlands',
  'es': 'Spain',
  'it': 'Italy',
  'pt': 'Portugal',
  'pl': 'Poland',
  'fi': 'Finland',
  'ie': 'Ireland',
  'jp': 'Japan',
  'sk': 'Slovakia',
  'cl': 'Chile',
  'ca': 'Canada',
  'au': 'Australia',
  'nz': 'New Zealand',
  'za': 'South Africa',
  'br': 'Brazil',
  'mx': 'Mexico',
  'in': 'India',
  'cn': 'China',
  'kr': 'South Korea',
  'ru': 'Russia',
  'ua': 'Ukraine',
  'cz': 'Czech Republic',
  'czechia': 'Czech Republic',
  'at': 'Austria',
  'ch': 'Switzerland',
  'se': 'Sweden',
  'no': 'Norway',
  'dk': 'Denmark',
  'hu': 'Hungary',
  'ro': 'Romania',
  'bg': 'Bulgaria',
  'hr': 'Croatia',
  'rs': 'Serbia',
  'gr': 'Greece',
  'tr': 'Turkey',
  'türkiye': 'Turkey',
  'il': 'Israel',
  'ae': 'United Arab Emirates',
  'uae': 'United Arab Emirates',
  'sg': 'Singapore',
  'my': 'Malaysia',
  'ph': 'Philippines',
  'id': 'Indonesia',
  'th': 'Thailand',
  'vn': 'Vietnam',
  'pk': 'Pakistan',
  'ng': 'Nigeria',
  'eg': 'Egypt',
  'ke': 'Kenya',
  'ar': 'Argentina',
  'co': 'Colombia',
  'pe': 'Peru',
};

export function normalizeCountry(raw: string | undefined | null): string {
  if (!raw) return '';
  const trimmed = raw.trim();
  const key = trimmed.toLowerCase();
  return COUNTRY_ALIASES[key] ?? trimmed;
}
